<template>
  <div>
    <div
      class="xs:inline-flex w-full border-grey-divider-subdued border-1 border-solid rounded-lg py-8 px-16 mb-28 bg-grey-background-contrast"
    >
      <p class="pr-8 pt-8">Looking for care?</p>
      <PoppinsButton id="signup" variant="text" :value="'Sign up as a parent'" :href="'/registration?member_type=seeker'" />
    </div>
    <h1 class="h1">Welcome, sitters</h1>
    <h2>
      Already have an account?
      <PoppinsButton id="login" variant="text" :value="'Log in'" :href="loginLink" size="large" />
    </h2>
  </div>
</template>

<script>
import Button from '@/components/button/Button.vue';

export default {
  name: 'SitterCreateFormHeader',
  components: {
    PoppinsButton: Button,
  },
  computed: {
    loginLink() {
      const urlParams = new URLSearchParams(window.location.search);
      const returnPath = urlParams.get('return_path');
      let link = '/login';
      if (returnPath) {
        link += `?return_path=${returnPath}`;
      }
      return link;
    },
  },
};
</script>
